import { wheatSorts, wheatTypes } from '@/modules/common/constants/wheat-types.constatnt';
import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { useState } from 'react';

const initialFormState: IInitialFormState = {
  id: 0,
  wheatType: undefined, //indicateWheatType(wheatSorts[0].label, wheatTypes[0].label),
  wheatClass: undefined,
  sort: undefined,//wheatSorts[0].label,
  type: undefined,//wheatTypes[0].label,
  year: new Date().getFullYear().toString(),
  gluten: '',
  idk: '',
  clop: '',
  protein: '',
  cp: '',
  nature: '',
  humidity: '',
  weed: '',
  admixtureOtherCereals: '',
  wheatDifferentType: '',
  expiryDate: '',
  buyingPrice: '',
  pickup: false,
};

export interface IInitialFormState {
  id: number;
  wheatType?: number,
  wheatClass?: number
  sort?: string,
  type?: string,
  year: string,
  gluten: string,
  idk: string
  clop: string
  protein: string
  cp: string
  nature: string
  humidity: string
  weed: string
  admixtureOtherCereals: string
  wheatDifferentType: string
  expiryDate: string
  buyingPrice: string
  pickup: boolean
};

export function useAddOfferFormState() {
  const [formState, setFormState] = useState(initialFormState);

  const handleChange = (
    fieldName: string,
    value: number | string | boolean,
    type: 'string' | 'number' | 'float' = 'string',
    max: number | null = null,
  ) => {
    setFormState({
      ...formState,
      [fieldName]:
        type === 'number'
          ? (max !== null && +String(value).replace(/\D/g, '') > max ? max : String(value).replace(/\D/g, '') || '')
          : type === 'float'
          ? (max !== null && +String(value).replace(/[^\d.]|(?<=\..*)\./g, '') > max ? max : String(value).replace(/[^\d.]|(?<=\..*)\./g, '') || '')
          : value,
    });
  };

  const resetForm = () => {
    setFormState(initialFormState);
  };

  return {
    formState,
    handleChange,
    resetForm,
    setFormState,
  };
}
